import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss'
import format from 'date-fns/format';
import { add, isSameDay } from 'date-fns';
import { Dropdown, DropdownButton } from 'react-bootstrap';

function EPGDropdownButton({
  selectedDay,
  translationTexts,
  initialSelectedDay,
  daysMaxRange,
  handleOnSelectDay,
  locale,
  daysAfter,
  daysBefore,
  turnOffLive
}) {


  const { default: currentDateLocale } = require(`date-fns/locale/${locale}`);

  const formatWeekDayName = (day) => {
    return isSameDay(day, Date.now()) ? translationTexts?.today : format(day, 'EEE', { locale: currentDateLocale }).toUpperCase()
  }
  const formatDay = (day) => format(day, 'dd/MM', { locale: currentDateLocale });

  const getDaysBeforeAndAfter = React.useCallback((date, numItems) => {
    const days = [];
    let i;
    for (i = -Math.floor(numItems / 2); i < Math.ceil(numItems / 2); i++) {
      const day = add(date, { days: i }),
        formattedDay = formatDay(day),
        weekDayName = formatWeekDayName(day),
        enabled = i >= -parseInt(daysBefore) && i <= parseInt(daysAfter);

      if (enabled) {
        days.push({
          date: formattedDay,
          dayName: weekDayName,
          epochDate: day,
          enabled
        });
      }
    };
    return days;
  }, [currentDateLocale, daysAfter, daysBefore]);

  const daysTabList = getDaysBeforeAndAfter(initialSelectedDay, daysMaxRange);

  return (
    <div className="epgGridList_timeDropdown">
      <DropdownButton className="epgGridList_timeDropdown_button" title={formatWeekDayName(selectedDay) + (isSameDay(selectedDay, Date.now())? '' : ' ' + formatDay(selectedDay))} onClick={turnOffLive}>
        {
          daysTabList.map((dayItem, index) =>
            <Dropdown.Item
              className={'epgGridList_timeDropdown_item'}
              key={`navitem-${dayItem.date}-${index}`}
              onSelect={(event) => handleOnSelectDay(dayItem, event)}
            >{dayItem.dayName + (isSameDay(dayItem.epochDate, Date.now())? '' : ' ' + dayItem.date)}</Dropdown.Item>
          )
        }
      </DropdownButton>
    </div>
  );
};

export default React.memo(EPGDropdownButton);
